<template>
  <documents-table
    :headers="_headers"
    :items="_notes"
    :groupName="_groupName"
    :groupBy="_groupBy"
    :groupDesc="withinClientChart"
    sortBy="startTime"
    sortDesc
  >
    <template v-slot:toggle>
      <v-col cols="12" sm="3">
        <v-switch
          v-model="unsignedOnly"
          :label="
            isServiceCoordination
              ? 'Awaiting Signature'
              : 'Awaiting Supervisor Signature'
          "
        ></v-switch
      ></v-col>
    </template>
    <template v-slot:checkbox="{ item }">
      <v-icon
        v-if="
          (item.serviceCoordinationNoteId && item.scSignatureId) ||
          (item.sessionNoteId &&
            item.requiresSupervisorSignature &&
            item.supervisorSignatureId)
        "
        color="success"
        >mdi-check-box-outline</v-icon
      >
      <v-icon
        v-else-if="
          (item.serviceCoordinationNoteId && !item.scSignatureId) ||
          (item.sessionNoteId &&
            item.requiresSupervisorSignature &&
            !item.supervisorSignatureId)
        "
        >mdi-signature</v-icon
      >
    </template>
    <template v-slot:signature="{ selectedItem, loadFile }">
      <v-card-actions
        v-if="showSignaturePad(selectedItem)"
        class="justify-center"
      >
        <signature-pad
          @saveSignature="saveSignature(selectedItem, ...arguments, loadFile)"
        ></signature-pad>
      </v-card-actions>
    </template>
    <template v-slot:loading>
      <v-overlay v-if="loading" :value="true" :absolute="true">
        <v-card-text class="d-flex align-center justify-center">
          <v-progress-circular indeterminate size="45"></v-progress-circular>
          <v-subheader class="text-h5">Processing...</v-subheader>
        </v-card-text>
      </v-overlay>
    </template>
  </documents-table>
</template>

<script>
import DocumentsTable from "../../Client/Details/documents-table";
import SignaturePad from "../../Shared/signature-pad.vue";
import DownloadZipButton from "../../Shared/download-zip-btn";
export default {
  components: { DocumentsTable, SignaturePad, DownloadZipButton },
  props: ["clientId", "isServiceCoordination", "notes"],

  data() {
    return {
      unsignedOnly: false,
      loading: false,
    };
  },
  computed: {
    withinClientChart() {
      return Boolean(this.clientId);
    },
    _headers() {
      var headers = [
        {
          text: "Provider Name",
          value: "providerName",
        },
        {
          text: "Date",
          value: "formattedDateOfService",
          hide: this.isServiceCoordination && this.withinClientChart, // it's the group header
        },
        {
          text: "Client Name",
          value: "clientName",
          hide: this.withinClientChart,
        },
        {
          text: "Service",
          value: "service",
          hide: this.isServiceCoordination || this.withinClientChart, // all same service || group header
        },
        {
          text: "Signed",
          value: this.isServiceCoordination
            ? "scSignatureId"
            : "supervisorSignatureId",
        },
      ];
      return headers.filter((x) => !x.hide);
    },
    _groupBy() {
      return this.withinClientChart
        ? this.isServiceCoordination
          ? "dateOfService"
          : "service"
        : "clientName";
    },
    _groupName() {
      return this.withinClientChart
        ? this.isServiceCoordination
          ? "formattedDateOfService" // within session note lookup - for service coordination notes
          : "service" // within session note lookup - for session notes
        : "clientName"; // within client chart
    },
    providerId() {
      return this.$store.state.sharedModule.providerId;
    },
    _notes() {
      return this.unsignedOnly // if unsignedOnly -> return notes that require signature (based on the note type)
        ? this.isServiceCoordination
          ? this.notes.filter((item) => !item.scSignatureId)
          : this.notes.filter(
              (item) =>
                item.requiresSupervisorSignature && !item.supervisorSignatureId
            )
        : this.notes; // else -> return the notes passed in as props
    },
    zipFileName: function () {
      return this.isServiceCoordination
        ? "Service_Coordination_Notes.zip"
        : "Session_Notes.zip";
    },
  },
  methods: {
    showSignaturePad(selectedItem) {
      // if note requires the current user's signature
      return this.isServiceCoordination
        ? selectedItem.providerId === this.providerId &&
            !selectedItem.scSignatureId
        : selectedItem.supervisorId === this.providerId &&
            !selectedItem.supervisorSignatureId;
    },
    async saveSignature(selectedItem, consentedAt, data, loadFile) {
      this.loading = true;
      if (this.isServiceCoordination) {
        var response = await this.$store.dispatch(
          "clientModule/signServiceCoordinationNote",
          {
            serviceCoordinationNoteId: selectedItem.serviceCoordinationNoteId,
            consentedAt: consentedAt,
            signatureURI: data,
          }
        );
      } else {
        var response = await this.$store.dispatch(
          "clientModule/signSessionNote",
          {
            sessionNoteId: selectedItem.sessionNoteId,
            consentedAt: consentedAt,
            signatureURI: data,
          }
        );
      }
      this.loading = false;
      if (response.success) {
        loadFile(response.data);
      }
      if (!response.success) {
        this.$store.commit("uxModule/setSnackbarMsg", "Error signing note");
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
  },
};
</script>